import React from "react";
import { Box, Typography } from "@mui/material";
import yellowSymbol from "../../assets/yellow-symbol-1.png";
import cdhLogo from "../../assets/hublogo1.png";
import { useNavigate } from "react-router-dom";

const HeroSection = ({ title, activeMenu, activeSubMenu }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "90px",
        backgroundColor: "#ffd700",
        padding: "0 15px",
        position: "relative",
        overflow: "visible",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#backgroundColor: '#FFD700',",

          position: "absolute",
          left: { xs: "50%", md: "2%" },
          top: { xs: "-10px", md: "-30px" },
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transform: { xs: "translateX(-50%)", md: "translateX(-2%)" },
          marginBottom: { xs: "0px", md: 0 },
          width: { xs: "100%", md: "auto" },
          height: { xs: "100%", md: "auto" },
        }}
      >
        <img
          src={cdhLogo}
          alt="USM Logo"
          style={{ height: "auto", width: "300px" }}
          onClick={() => navigate(`/`)}
        />
      </Box>
      <Box
        sx={{
          marginLeft: "77px",
        }}
      >
        {/*<Typography
            variant="h3"
            fontWeight="bold"
            color="textPrimary"
            sx={{ 
              display:"inline",
                textTransform: "uppercase", 
                marginTop: "68px",
                fontSize: { xs: "1.5rem", sm: "2rem", md: "0.9rem" }, 
                letterSpacing: "2px", 
                borderBottom:"2px solid #ffffff",
                color: "#ffffff", 
                transition: "all 0.3s ease",
                "&:hover": { 
                    color: "#000000",
                    borderBottomColor:"#000000"
                    },
                    display:{xs:'none', md:'block'}

                     }}
          >
        {title}          </Typography>*/}
      </Box>
    </Box>
  );
};

export default HeroSection;
